/**
 * The below file contains the constants used in the flood report.
 * @author: shivam.sharma2@velsof.com
 * @date : 28-12-2022
 */

/**Constants for flood Listing page */
export const GET_ALL_FLOOD = "GET_ALL_FLOOD";
export const SET_FLOOD_LISTING = "SET_FLOOD_LISTING";
export const SET_FLOOD_LISTING_PARAM = "SET_FLOOD_LISTING_PARAM";
export const GET_EXPORT_FLOOD_DATA = "GET_EXPORT_FLOOD_DATA";
export const SET_EXPORT_FLOOD_DATA = "SET_EXPORT_FLOOD_DATA";
/**Constants for flood Listing page */

/**Constants for flood Import page */
export const FLOOD_IMPORT = "FLOOD_IMPORT";
/**Constants for flood Import page */

//#region All Section
/**Constants for all section details
 * @author: shivam.sharma2@velsof.com
 * @date : 28-12-2022
 */
export const FLOOD_GET_ALL_SECTION = "FLOOD_GET_ALL_SECTION";
export const FLOOD_SET_ALL_SECTION = "FLOOD_SET_ALL_SECTION";
export const FLOOD_SET_RELIEF_CENTER_SECTION =
  "FLOOD_SET_RELIEF_CENTER_SECTION";
export const FLOOD_RESET_BUTTON_LOADING = "FLOOD_RESET_BUTTON_LOADING";
export const FLOOD_SET_PARENT_ID = "FLOOD_SET_PARENT_ID";
export const FLOOD_REPORT_SUBMIT = "FLOOD_REPORT_SUBMIT";
export const FLOOD_REPORT_DISCARD = "FLOOD_REPORT_DISCARD";
export const FLOOD_SET_REDIRECT_TO_LISTING = "FLOOD_SET_REDIRECT_TO_LISTING";
export const FLOOD_SET_DATA_SAVED = "FLOOD_SET_DATA_SAVED";
//#endregion All Section

//#region Basic Section
/**Constants for adding the basic section details
 * @author: shivam.sharma2@velsof.com
 * @date : 28-12-2022
 */
export const FLOOD_ADD_BASIC_SECTION = "FLOOD_ADD_BASIC_SECTION";
export const FLOOD_EDIT_BASIC_SECTION = "FLOOD_EDIT_BASIC_SECTION";
export const FLOOD_SET_NIL_REPORTING = "FLOOD_SET_NIL_REPORTING";
//#endregion Basic Section

//#region InfDamage Section
/**Constants for adding the infrastructure damage details
 * @author: shivam.sharma2@velsof.com
 * @date : 28-12-2022
 */
export const FLOOD_ADD_INFDAMAGE_SECTION = "FLOOD_ADD_INFDAMAGE_SECTION";
//#endregion InfDamage Section

//#region InfDamageOther Section
/**Constants for adding the infrastructure others damage details
 * @author: shivam.sharma2@velsof.com
 * @date : 28-12-2022
 */
export const FLOOD_ADD_INFDAMAGEOTHER_SECTION =
  "FLOOD_ADD_INFDAMAGEOTHER_SECTION";
//#endregion InfDamageOther Section

//#region Remark Section
/**Constants for adding the Remark details
 * @author: shivam.sharma2@velsof.com
 * @date : 28-12-2022
 */
export const FLOOD_ADD_REMARK_SECTION = "FLOOD_ADD_REMARK_SECTION";
//#endregion Remark Section

//#region PopAffected Section
/**Constants for adding the population affected details
 * @author: shivam.sharma2@velsof.com
 * @date : 28-12-2022
 */
export const FLOOD_ADD_POPAFFECTED_SECTION = "FLOOD_ADD_POPAFFECTED_SECTION";
//#endregion PopAffected Section

//#region Eroded Section
/**Constants for adding the eroded details
 * @author: shivam.sharma2@velsof.com
 * @date : 28-12-2022
 */
export const FLOOD_ADD_ERODED_SECTION = "FLOOD_ADD_ERODED_SECTION";
//#endregion Eroded Section

//#region Relief Camp Section
/**Constants for adding the relief camp details
 * @author: shivam.sharma2@velsof.com
 * @date : 28-12-2022
 */
export const FLOOD_ADD_RELIEFCAMP_SECTION = "FLOOD_ADD_RELIEFCAMP_SECTION";
//#endregion relief camp Section

//#region Camp Inmates Section
/**Constants for adding the camp Inmates details
 * @author: shivam.sharma2@velsof.com
 * @date : 28-12-2022
 */
export const FLOOD_ADD_CAMPINMATES_SECTION = "FLOOD_ADD_CAMPINMATES_SECTION";
//#endregion Camp Inmates Section

//#region Camp Non Inmates Section
/**Constants for adding the camp Inmates details
 * @author: vishal.mishra@velsof.com
 * @date : 13-03-2024
 */
export const FLOOD_ADD_NONCAMPINMATES_SECTION =
  "FLOOD_ADD_NONCAMPINMATES_SECTION";
//#endregion Camp Inmates Section

//#region Human Live Lost Section
/**Constants for adding the Human Live Lost details
 * @author: shivam.sharma2@velsof.com
 * @date : 28-12-2022
 */
export const FLOOD_ADD_HLL_SECTION = "FLOOD_ADD_HLL_SECTION";
//#endregion Human Live Lost Section

//#region LiveStock Section
/**Constants for adding the LiveStock details
 * @author: shivam.sharma2@velsof.com
 * @date : 28-12-2022
 */
export const FLOOD_ADD_LIVESTOCK_SECTION = "FLOOD_ADD_LIVESTOCK_SECTION";
//#endregion LiveStock Section

//#region HouseDamaged Section
/**Constants for adding the HouseDamaged details
 * @author: shivam.sharma2@velsof.com
 * @date : 28-12-2022
 */
export const FLOOD_ADD_HOUSEDAMAGED_SECTION = "FLOOD_ADD_HOUSEDAMAGED_SECTION";
//#endregion HouseDamaged Section

//#region RescueOperation Section
/**Constants for adding the RescueOperation details
 * @author: shivam.sharma2@velsof.com
 * @date : 28-12-2022
 */
export const FLOOD_ADD_RESCUEOPERATION_SECTION =
  "FLOOD_ADD_RESCUEOPERATION_SECTION";
//#endregion RescueOperation Section

//#region ReliefDistribution Section
/**Constants for adding the ReliefDistribution details
 * @author: shivam.sharma2@velsof.com
 * @date : 28-12-2022
 */
export const FLOOD_ADD_RELIEFDISTRIBUTION_SECTION =
  "FLOOD_ADD_RELIEFDISTRIBUTION_SECTION";
//#endregion ReliefDistribution Section

/**Constants for adding the approve & disapprove constants
 * @author: shivam.sharma2@velsof.com
 * @date : 28-12-2022
 */
//#region Report and Approval and Disapproval
export const FLOOD_REVENUE_REPORT_APPROVE = "FLOOD_REVENUE_REPORT_APPROVE";
export const FLOOD_REVENUE_REPORT_DISAPPROVE =
  "FLOOD_REVENUE_REPORT_DISAPPROVE";
export const FLOOD_REVENUE_REPORT_VERIFY = "FLOOD_REVENUE_REPORT_VERIFY";

export const EXPORT_FO_LEVEL_FLOOD_REPORT = "EXPORT_FO_LEVEL_FLOOD_REPORT";
export const SET_EXPORT_FO_LEVEL_FLOOD_REPORT =
  "SET_EXPORT_FO_LEVEL_FLOOD_REPORT";

export const FLOOD_DISTRICT_REPORT_APPROVE = "FLOOD_DISTRICT_REPORT_APPROVE";
export const FLOOD_DISTRICT_REPORT_DISAPPROVE =
  "FLOOD_DISTRICT_REPORT_DISAPPROVE";
export const FLOOD_DISTRICT_REPORT_VERIFY = "FLOOD_DISTRICT_REPORT_VERIFY";

export const FLOOD_STATE_REPORT_APPROVE = "FLOOD_STATE_REPORT_APPROVE";
export const FLOOD_STATE_REPORT_DISAPPROVE = "FLOOD_STATE_REPORT_DISAPPROVE";

export const GET_FLOOD_DISTRICT_REVIEW_LIST = "GET_FLOOD_DISTRICT_REVIEW_LIST";
export const SET_FLOOD_DISTRICT_REVIEW_LIST = "SET_FLOOD_DISTRICT_REVIEW_LIST";
export const GET_FLOOD_STATE_REVIEW_LIST = "GET_FLOOD_STATE_REVIEW_LIST";
export const SET_FLOOD_STATE_REVIEW_LIST = "SET_FLOOD_STATE_REVIEW_LIST";

export const SET_DISTRICT_FLOOD_REPORT = "SET_DISTRICT_FLOOD_REPORT";
export const GET_DISTRICT_FLOOD_REPORT = "GET_DISTRICT_FLOOD_REPORT";
export const GET_STATE_CUMULATIVE_FLOOD_REPORT =
  "GET_STATE_CUMULATIVE_FLOOD_REPORT";
export const SET_STATE_CUMULATIVE_FLOOD_REPORT =
  "SET_STATE_CUMULATIVE_FLOOD_REPORT";
export const GET_DISTRICT_CUMULATIVE_FLOOD_REPORT =
  "GET_DISTRICT_CUMULATIVE_FLOOD_REPORT";
export const SET_DISTRICT_CUMULATIVE_FLOOD_REPORT =
  "SET_DISTRICT_CUMULATIVE_FLOOD_REPORT";
//#endregion Report and Approval and Disapproval

//#region for flood form freeze unfreeze report for a selected Range
export const FREEZE_UNFREEZE_FLOOD_RANGE_REPORT =
  "FREEZE_UNFREEZE_FLOOD_RANGE_REPORT";
